import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppConfigService } from 'src/app/services/app-config.service';
import { ConfigurationService } from 'src/app/services/configuration.service';
import { SessionService } from 'src/app/services/session.service';

@Component({
  selector: 'app-nav-bar',
  templateUrl: './nav-bar.component.html',
  styleUrls: ['./nav-bar.component.scss']
})
export class NavBarComponent implements OnInit {

  constructor(
    private router: Router,
    private sessionService: SessionService,
    private appConfigService: AppConfigService,
    private configurationService: ConfigurationService) { }

  ngOnInit(): void {
  }

  public isLoginVisible(): boolean {
    return !this.sessionService.isAuthenticated();
  }

  public isLogoutVisible(): boolean {
    return this.sessionService.isAuthenticated();
  }

  public getDashboardClasses(): string {
    return this.getRouteArea() === 'dashboard' ? 'active-nav' : '';
  }

  public getContactClasses(): string {
    return this.getRouteArea() === 'contact' ? 'active-nav' : '';
  }

  public getLoginClasses(): string {
    return this.getRouteArea() === 'login' ? 'active-nav' : '';
  }

  public getLogoutClasses(): string {
    return this.getRouteArea() === 'logout' ? 'active-nav' : '';
  }

  public getLogoUrl(): string {
    return this.configurationService.getNavLogoUrl();
  }

  public getTitle(): string {
    return this.configurationService.getNavTitle();
  }

  public isCollexusVersion(): boolean {
    return this.appConfigService.getConfig().htmlVersion !== 'version1';
  }

  public getLogoLink(): string {
    return this.appConfigService.getConfig().defaultConfiguration.navLogoLink;
  }

  private getRouteArea(): string {
    let result = '';

    switch (this.router.url) {
      case '/contact':
        result = 'contact';
        break;
      case '/login':
        result = 'login';
        break;
      case '/logout':
        result = 'logout';
        break;
      default:
        result = 'dashboard';
    }

    return result;
  }
}
